module.exports = __webpack_public_path__ + "img/wow_pattern_web.838a8f16.svg";